import getFontClass from '../../utils/getFontClass';
import shoppableImage from '../helpers/ShoppableImage';

const generateHeading = (headings) => {
  let html = '';

  headings.forEach((heading) => {
    html += `<span class="${getFontClass(heading.heading_size)}">${heading.heading_text}</span>`;
  });
  return html;
};

// export default (settings, module_name, index) => {
export default (settings, module_name) => {
  const content_html = `
  <div class="Module-${module_name}__Columns">
    <div class="Module-${module_name}__Column Module-${module_name}__Left">
      <div class="Module-${module_name}__Column-Inner Module-${module_name}__Left-inner">
        ${shoppableImage(settings.image, settings.accent_color.accent_color)}
      </div>
    </div>
    <div class="Module-${module_name}__Column Module-${module_name}__Right">
      <div class="Module-${module_name}__Column-Inner Module-${module_name}__Right-inner">
        <div class="Module-${module_name}__Block Module-${module_name}__Block--Content">
          <h2 class="Module-${module_name}__Header">${generateHeading(settings.heading || [])}</h2>
        </div>
      </div>
    </div>
  </div>
  `;
  return content_html;
};
